// Reusable footer styles for the Pre-built library. Each = a small block group
// inserted at the BOTTOM of the email.
import { social, footerBlk, text, divider, columns, image } from './builders'

const FOOTERS = [
  {
    id: 'ftr-standard',
    name: 'Standard (address + social)',
    blocks: [
      divider({ color: '#E5E7EB' }),
      social({ alignment: 'center', iconColor: '#6B7280', paddingBottom: 8 }),
      footerBlk('Your Company Name · 123 Street, City, Country<br/><a href="#" style="color:#6B7280;">Unsubscribe</a> · <a href="#" style="color:#6B7280;">Manage preferences</a>', { backgroundColor: '#f8f8f8' }),
    ],
  },
  {
    id: 'ftr-compact',
    name: 'Compact',
    blocks: [
      social({ alignment: 'center', iconSize: '28', iconColor: '#9CA3AF', paddingTop: 12, paddingBottom: 4 }),
      footerBlk('© Your Company · <a href="#" style="color:#9CA3AF;">Unsubscribe</a>', { backgroundColor: '', color: '#9CA3AF', fontSize: '11', paddingTop: 6 }),
    ],
  },
  {
    id: 'ftr-branded',
    name: 'Branded Color Block',
    blocks: [
      social({ alignment: 'center', iconColor: '#ffffff', backgroundColor: '#111827', paddingTop: 20, paddingBottom: 4 }),
      footerBlk('Your Company Name · 123 Street, City<br/><a href="#" style="color:#D1D5DB;">Unsubscribe</a>', { backgroundColor: '#111827', color: '#D1D5DB' }),
    ],
  },
  {
    id: 'ftr-contact',
    name: 'Contact / Support',
    blocks: [
      divider({ color: '#E5E7EB' }),
      text('<p style="text-align:center"><strong>Need help?</strong><br/>📞 +00 000 0000 &nbsp;·&nbsp; ✉️ support@yourcompany.com<br/>Mon–Fri, 9am–6pm</p>', { alignment: 'center', color: '#374151', fontSize: '13' }),
      footerBlk('<a href="#" style="color:#6B7280;">Unsubscribe</a> · <a href="#" style="color:#6B7280;">Preferences</a>', { backgroundColor: '#f8f8f8', fontSize: '11' }),
    ],
  },
  {
    id: 'ftr-app',
    name: 'App Download',
    blocks: [
      text('<p style="text-align:center"><strong>Get the app</strong></p>', { alignment: 'center', color: '#111827', fontSize: '15', paddingBottom: 4 }),
      columns([
        [image('https://placehold.co/135x40/000000/ffffff.png?text=App+Store', { width: '90', alignment: 'right' })],
        [image('https://placehold.co/135x40/000000/ffffff.png?text=Google+Play', { width: '90', alignment: 'left' })],
      ], { gap: '8', paddingBottom: 8 }),
      footerBlk('Your Company · <a href="#" style="color:#6B7280;">Unsubscribe</a>', { backgroundColor: '#f8f8f8', fontSize: '11' }),
    ],
  },
]

export default FOOTERS
